import React from 'react';
import { GroupMember } from '../types';
import EmptyState from '../../../../../UI/EmptyState';
import UserCard from './UserCard';
import styles from '../../../../../../styles/UserManagementTab.module.css';

interface UserListProps {
  members: GroupMember[];
  loading: boolean;
  selectedMemberIds: Set<string>;
  onSelectMember: (memberId: string) => void;
  onEditMember: (member: GroupMember) => void;
  onDeleteMember: (member: GroupMember) => void;
  groupId: string;
  canManageUsers: boolean;
  onAddMember: () => void;
}

const UserList: React.FC<UserListProps> = ({
  members,
  loading,
  selectedMemberIds,
  onSelectMember,
  onEditMember,
  onDeleteMember,
  groupId,
  canManageUsers,
  onAddMember
}) => {
  if (loading) {
    return (
      <div className={styles.userList}>
        {Array.from({ length: 4 }, (_, index) => (
          <div key={index} className={styles.userCardSkeleton}>
            <div className={styles.skeletonCardHeader}>
              <div className={styles.skeletonCardHeaderLeft}>
                <div className={styles.skeletonCheckbox}></div>
                <div className={styles.skeletonIconWrapper}></div>
                <div className={styles.skeletonTitleSection}>
                  <div className={styles.skeletonTitle}></div>
                  <div className={styles.skeletonDescription}></div>
                </div>
              </div>
              <div className={styles.skeletonCardHeaderRight}>
                <div className={styles.skeletonStatusBadge}></div>
                <div className={styles.skeletonCardActions}>
                  <div className={styles.skeletonActionBtn}></div>
                  <div className={styles.skeletonActionBtn}></div>
                  <div className={styles.skeletonActionBtn}></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (members.length === 0) {
    return (
      <EmptyState
        image="/images/notasks.png"
        title="No Members Found"
        description="This group doesn't have any members yet. Start by inviting or adding members to get your team together."
        action={canManageUsers ? {
          label: "Add First Member",
          onClick: onAddMember
        } : undefined}
      />
    );
  }

  return (
    <div className={styles.userList}>
      {members.map(member => {
        if (!member || !member.user) {
          return null;
        }
        
        return (
          <UserCard
            key={member.id}
            member={member}
            isSelected={selectedMemberIds.has(member.id)}
            onSelect={onSelectMember}
            onEdit={onEditMember}
            onDelete={onDeleteMember}
            groupId={groupId}
            canManageUsers={canManageUsers}
          />
        );
      })}
    </div>
  );
};

export default UserList;

